
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/tickets/[slug]/scene/[sceneId]",
      function () {
        return require("private-next-pages/[locale]/tickets/[slug]/scene/[sceneId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/tickets/[slug]/scene/[sceneId]"])
      });
    }
  